import { render, staticRenderFns } from "./FormPsicotecnicoEdicao.vue?vue&type=template&id=570d889a"
import script from "./FormPsicotecnicoEdicao.vue?vue&type=script&lang=js"
export * from "./FormPsicotecnicoEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports